import ApplicationController from './application_controller';
import { stringify } from 'querystring';
import { titleCase } from './helpers/utils';

export default class extends ApplicationController {
    static targets = [
        'estimatedPlan',
        'form',
        'planInput',
        'estimatedPlanInput',
        'estimatedAmount',
        'estimatedAnnualAmount',
        'planIdInput',
        'revenueOptions',
        'planName',
        'basePrice',
        'currentPlan',
        'submit',
        'nextPlan',
        'nextAnnualPlan',
        'proRataText',
        'selectionSummary',
        'annualSelectionSummary',
    ];

    connect() {
        if (this.hasRevenueOptionsTarget) {
            this.selectRevenueRange();
            if (this.element.dataset.isAdmin !== 'true') {
                this.disableRevenueOptions();
            }
        }
    }

    disableRevenueOptions() {
        for (let option of this.revenueOptionsTarget.options) {
            if (parseFloat(option.value) < parseFloat(this.element.dataset.organizationVerifiedRevenue)) {
                option.setAttribute('disabled', '');
            }
        }
    }

    selectRevenueRange() {
        for (let option of this.revenueOptionsTarget.options) {
            if (parseFloat(option.value) >= parseFloat(this.element.dataset.organizationVerifiedRevenue)) {
                option.setAttribute('selected', '');
                break;
            }
        }
    }

    estimateBilling() {
        this.disableSaveButton();
        this.estimateBillingPrice(this.revenueOptionsTarget.value);
    }

    estimateBillingPrice(revenue) {
        var context = this;
        this.ajax({
            url: this.element.dataset.url,
            type: 'POST',
            dataType: 'json',
            data: stringify({
                revenue: revenue,
                current_plan: this.element.dataset.currentPlan,
            }),
            success: function (data) {
                if (context.element.dataset.currentPlan != data.identifier) {
                    context.estimatedPlanInputTarget.value = data.identifier;
                    context.estimatedPlanTarget.classList.remove('hidden');
                    context.nextPlanTarget.innerHTML = `${data.recurring_interval}ly ${titleCase(data.billing_product_name)}`;
                    context.selectionSummaryTarget.classList.remove('hidden');
                    context.estimatedAmountTarget.innerHTML = `${data.plan_amount}`;
                } else {
                    context.estimatedPlanInputTarget.value = null;
                    context.estimatedPlanTarget.classList.add('hidden');
                }
                context.enableSaveButton();
            },
        });
    }

    enableSaveButton() {
        this.sendEvent(this.formTarget, 'form:check-required-fields');
    }

    disableSaveButton() {
        this.submitTarget.setAttribute('disabled', '');
        this.submitTarget.classList.add('form-disabled');
    }

    addAttribute(element, attribute, value) {
        element.setAttribute(attribute, (element.getAttribute(attribute) || '') + ' ' + value);
    }

    replaceAttribute(element, attribute, oldVal, newVal) {
        element.setAttribute(attribute, (element.getAttribute(attribute) || '').replace(oldVal, newVal));
    }
}
